import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import "moment/locale/pt-br";
import styles from './styles.module.scss';
import { putQuiz, postQuiz, getQuizById } from '../../../services/api-auto';
import { useGetUser } from '../../../hooks/useGetUser';
import { useDispatch } from "react-redux";
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction
} from '../../../store/actions/snackbarActions.js';
import ModalLoading from '../../../components/ModalLoading';
import TextField from '@material-ui/core/TextField';
import { Select, MenuItem, InputLabel, FormControlLabel, Radio, RadioGroup, FormLabel, FormGroup } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import FormControl from '@material-ui/core/FormControl';
import MomentUtils from "@date-io/moment";
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain';
import { number } from '../../../services/mask';

const dataInit = {
    titulo: "",
    textoDestaque: "",
    periodoAtividade: 0,
    status: 1,
    dataInicio: null,
    dataFim: null,
    urlImagemMobile: "",
    urlImagemDesktop: "",
    tipo: {
        quizTipoId: "7D9C0637-CF9F-485E-8196-347F81E9E4AD"
    },
    ativo: true,
    perguntas: [{
        ordem: 1,
        texto: "",
        pontos: null,
        respostas: [
            {
                ordem: 1,
                texto: "",
                correta: true
            },
            {
                ordem: 2,
                texto: "",
                correta: false
            },
            {
                ordem: 3,
                texto: "",
                correta: false
            }]
        }]
}


const QuizDetalhe = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory();
    const [data, setData] = useState(dataInit);
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [quizId, setQuizId] = useState();

    const validarForm = () => {

        let valid = true;
        let msg = "";

        if(!data.titulo) {
            msg += `O campo Título é obrigatório. `; 
            valid = false; 
            showMsgW(msg)
        }
        if(data.periodoAtividade === 1 && (!data.dataInicio || !data.dataFim)) {
            msg += "As datas são obrigatórias quando o período de atividade for determinado. "; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.textoDestaque) {
            msg += "O campo Texto de destaque é obrigatório. "; 
            valid = false; 
            showMsgW(msg)
        }
        if( !data.urlImagemDesktop ) {
            msg += "Você deve carregar as imagens para salvar. "; 
            valid = false; 
            showMsgW(msg)
        }

        if( data.perguntas.some(x => !x.pontos || (x.pontos && x.pontos === 0))) {
            msg += "Você deve informar a pontuação para cada pergunta."; 
            valid = false; 
            showMsgW(msg)
        }

        if( data.perguntas.some(x => !x.texto)) {
            msg += "Você deve informar o texto para cada pergunta."; 
            valid = false; 
            showMsgW(msg)
        }

        if( data.perguntas.some(x => x.respostas.some(y => !y.texto))) {
            msg += "Você deve informar o texto para cada resposta."; 
            valid = false; 
            showMsgW(msg)
        }

        if(msg) 
            showMsgW(msg)

        setIndicarErros(!valid);
        return valid;
    }

    const getQuizIfEdit = async (id) => {

        if(id) {
            setModalLoading(true);
            try{
                const info = await getQuizById(id);
                setData(info.data);

            } catch(e){
                showMsgW('Não foi possível carregar os dados');
            }
            setModalLoading(false);
        }
    }

    const enviar = async() => {
        setIndicarErros(false);
        if(validarForm()) {
            let formdata = data;

            formdata.dataInicio = formdata.periodoAtividade === 0 ? null : formdata.dataInicio;
            formdata.dataFim = formdata.periodoAtividade === 0 ? null : formdata.dataFim;
            formdata.ativo = formdata.status === 1;
            formdata.urlImagemMobile = formdata.urlImagemDesktop;
            
            if( quizId !== null ) {
                setModalLoading(true);
                try{
                    let info = await putQuiz(quizId, formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/quiz')
                    }, 2000);
                } catch(e){
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false);
            } else {
                setModalLoading(true);
                try{
                    let info = await postQuiz(formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/quiz');
                    }, 2000);
                } catch(e) {
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false);
            }
        }
    }

    const setArrayPerguntasData = (value, position, field) => {
        
        let dataModify = data.perguntas;

        switch (field) {
            case 'pergunta' :dataModify[position].texto = value; break;
            case 'ordem' : dataModify[position].ordem = parseInt(value); break;
            case 'pontos' : dataModify[position].pontos = parseInt(value); break;
            default: break;
        }

        setData({ ...data, perguntas: dataModify });

    }

    const setArrayRespostaData = (value, position, positionQuestion, field) => {
        
        let dataModify = data.perguntas;

        let dataResp = dataModify.find(x => x.ordem === positionQuestion).respostas;

        switch (field) {
            case 'texto' : dataResp[position].texto = value; break;
            case 'correta' : dataResp.forEach(x => { x.correta = false; }); dataResp[position].correta = true; break;
            default: break;
        }

        setData({ ...data, perguntas: [...dataModify] });

    }

    const addQuestion = () => {
        
        var order = data.perguntas.length + 1;

        var questions = {
            ordem: order,
            texto: "",
            pontos: null,
            respostas: [
                {
                    ordem: 1,
                    texto: "",
                    correta: true
                },
                {
                    ordem: 2,
                    texto: "",
                    correta: false
                },
                {
                    ordem: 3,
                    texto: "",
                    correta: false
                }]
            };
        
        var dataModify = data.perguntas;
        dataModify.push(questions);

        setData({ ...data, perguntas: [...dataModify] });
    }

    useEffect( () => {
        const id = new URLSearchParams(history.location.search).get("QuizId");
        setQuizId(id);
        getQuizIfEdit(id);
    },[])

    const user = useGetUser();

    return (
        <>
        {( user.perfilAcesso === 'Master' ) && (
            <>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        Quiz
                        <button className={styles.backButton} onClick={() => {history.goBack()}}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                    </div>

                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                                <div className={styles.subtitle}>
                                    Configuração
                                </div>
                                <FormControl>
                                    <TextField  type="text"  size="small"
                                        onChange={(e) => {setData({ ...data, titulo:e.target.value})}}
                                        label="Título"
                                        value={data.titulo}
                                        variant="filled"
                                        error={indicarErros && !data.titulo ? true : false}
                                        className="customFilledInput"
                                    />
                                </FormControl>
                                <FormControl>
                                    <InputLabel id="select-status-label">
                                        Status
                                    </InputLabel>
                                    <Select
                                        labelId='select-status-label'
                                        label="Status"
                                        onChange={(e)=>{setData({...data, status: e.target.value})}}
                                        value={data.status}
                                        variant="filled"
                                        className="customFilledInput"
                                    >
                                        <MenuItem value={0}>Inativo</MenuItem>
                                        <MenuItem value={1}>Ativo</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl>
                                    <TextField  type="text"  size="small"
                                        onChange={(e) => {setData({ ...data, textoDestaque: e.target.value})}}
                                        label="Texto de destaque"
                                        value={data.textoDestaque}
                                        variant="filled"
                                        error={indicarErros && !data.textoDestaque ? true : false}
                                        className="customFilledInput"
                                    />
                                </FormControl>

                                <FormControl className={styles.halfRadio}>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Período de atividade</FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue={0}
                                        value={data.periodoAtividade}
                                        style={{flexWrap: "nowrap"}}
                                        onChange={(e) => {setData({ ...data, periodoAtividade: parseInt(e.target.value), dataFim: null})}}
                                    >
                                        <FormControlLabel value={0} control={<Radio style={{color: "#5CCBE1"}}/>} label="Indeterminado" />
                                        <FormControlLabel value={1} control={<Radio style={{color: "#5CCBE1"}}/>} label="Determinado" />
                                    </RadioGroup>
                                </FormControl>
                                
                                <FormControl className={styles.data}>
                                    <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            label="De"
                                            format="DD/MM/yyyy"
                                            value={data.dataInicio}
                                            InputAdornmentProps={{ position: "start" }}
                                            onChange={novaData => { setData({ ...data, dataInicio: novaData}) }}
                                            className="customFilledInput"
                                            error={indicarErros && !data.dataInicio ? true : false}
                                            hidden={data.periodoAtividade === 0}
                                            invalidDateMessage="Data em formato inválido."
                                            maxDateMessage="Data não deve ser maior que a data máxima."
                                            minDateMessage="Data não deve ser menor que a data mínima."
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormControl>
                                <FormControl className={styles.data}>
                                    <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            label="Até"
                                            format="DD/MM/yyyy"
                                            value={data.dataFim}
                                            InputAdornmentProps={{ position: "start" }}
                                            onChange={novaData => { setData({ ...data, dataFim: novaData}) }}
                                            className="customFilledInput"
                                            error={indicarErros && !data.dataFim ? true : false}
                                            hidden={data.periodoAtividade === 0}
                                            invalidDateMessage="Data em formato inválido."
                                            maxDateMessage="Data não deve ser maior que a data máxima."
                                            minDateMessage="Data não deve ser menor que a data mínima."
                                        />
                                    </MuiPickersUtilsProvider>
                                </FormControl>
                            </div>
                        </div>
                    </div>

                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card}>
                                <div className={styles.subtitle}>
                                    Imagens
                                </div>
                                <div className={styles.divImageList}>
                                    <FormGroup>
                                        <ButtonsImagesCampain
                                            smallText = 'Imagem Desktop'
                                            texto = 'Destaque que será exibido no portal do participante.'
                                            width = '1200'
                                            height = '600'
                                            widthMM = '317.5'
                                            heightMM = '158.75'
                                            image={data.urlImagemDesktop}
                                            changeImage={(file)=>{setData({...data, 'urlImagemDesktop': file})}}
                                            error={indicarErros && !data.urlImagemDesktop ? true : false}
                                            obterLink={true}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div className={styles.content}>
                        <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                            <div className={styles.subtitle}>
                                Perguntas e respostas
                            </div>

                            <button className={styles.salvar} onClick={addQuestion} style={{marginBottom: '20px'}}>
                                Adicionar pergunta
                            </button>

                            { data.perguntas && 
                                data.perguntas.map((item, i) => (
                                    <div className={styles.contentQuestions}>
                                        <div className={styles.subtitle2}>{`Pergunta`}</div>
                                        <FormControl>
                                            <TextField  type="numeric"  size="small"
                                                onChange={(e) => {setArrayPerguntasData(i + 1, i, 'ordem')}}
                                                label="Ordem de exibição"
                                                value={i + 1}
                                                variant="filled"
                                                error={indicarErros && !data.ordem ? true : false}
                                                className="customFilledInput"
                                                disabled
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <TextField  
                                                size="small"
                                                onChange={(e) => {setArrayPerguntasData(e.target.value, i, 'pontos')}}
                                                label="Pontos"
                                                value={number(item.pontos)}
                                                variant="filled"
                                                error={indicarErros && !item.pontos ? true : false}
                                                className="customFilledInput"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <TextField  type="text"  size="small"
                                                onChange={(e) => {setArrayPerguntasData(e.target.value, i, 'pergunta') }}
                                                label="Pergunta"
                                                value={item.texto}
                                                variant="filled"
                                                error={indicarErros && !data.texto ? true : false}
                                                className="customFilledInput"
                                            />
                                        </FormControl>

                                        <div><small><b>Assinale a resposta correta</b></small></div>

                                        { 
                                            item.respostas.map((resp, r) => (
                                                <>
                                                
                                                    <FormControl className={styles.halfRadioText}>
                                                        <RadioGroup
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            defaultValue={false}
                                                            value={resp.correta}
                                                            style={{flexWrap: "nowrap"}}
                                                            onClick={(e) => {setArrayRespostaData(!resp.correta, r, item.ordem, 'correta') }}
                                                        >
                                                            <FormControlLabel value={resp.correta !== 'true'} control={<Radio style={{color: "#5CCBE1"}}/>} label={""} />
                                                        </RadioGroup>
                                                        <TextField  type="text"  size="small"
                                                                onChange={(e) => {setArrayRespostaData(e.target.value, r, item.ordem, 'texto') }}
                                                                label={`Resposta`}
                                                                value={resp.texto}
                                                                variant="filled"
                                                                error={indicarErros && !data.texto ? true : false}
                                                                className={` ${resp.correta ? styles.correct : "customFilledInput"}`}
                                                            />
                                                    </FormControl>
                                                    
                                                </>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                            
                        </div>
                    </div>
                    
                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card}>
                                <div className={styles.subtitle}>
                                    Ações
                                </div>
                                <button className={styles.encerrar} onClick={() => {if(window.confirm("Deseja cancelar esta edição? Todos os dados não salvos serão perdidos.")) { history.push("/quiz"); }}}>
                                    Cancelar
                                </button>
                                <button className={styles.salvar} onClick={enviar}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <ModalLoading
                    open={modalLoading} 
                    size="lg"
                />
            </>
        )}


        </>
    );
}

export default QuizDetalhe;